<template>
  <div class="step-header__wrapper">
    <div
      class="container step-header"
      :class="{
        'step-header--margin-sm': smallMargin,
        'no-margin': noMargin
      }"
    >
      <h3
        v-if="title"
        :class="titleClass"
      >
        {{ title }}
      </h3>

      <p
        v-if="subtitle"
        class="step-header__subtitle"
      >
        {{ subtitle }}
      </p>

      <p
        v-if="info"
        class="step-header__info"
        :class="textColorClass()"
      >
        {{ info }}
      </p>

      <h3
        v-if="$slots.default"
        class="step-header__slot step-header__title"
      >
        <slot />
      </h3>
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'StepHeader',

  // Mixins
  mixins: [
    theme
  ],

  // Props
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    info: {
      type: String,
      default: ''
    },
    smallMargin: {
      type: Boolean,
      default: false
    },
    shrinkMobileHeader: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    titleClass () {
      const classes = ['step-header__title']
      classes.push('step-header__title--variant')
      if (this.shrinkMobileHeader) {
        classes.push('step-header__title--small')
      }
      return classes.join(' ')
    }
  }

}
</script>

<style scoped lang="scss">
.step-header {
  @apply mb-20 text-center flex flex-col px-15;

  @screen sm {
    @apply px-30;
  }

  &__wrapper {
    @apply flex flex-col;
  }

  @screen sm {
    @apply mb-30;
  }

  @screen md {
    @apply mb-40;
  }

  &--margin-sm {
    @apply mb-[18px];
  }
  // This class will override the margin when noMargin is true
  &.no-margin {
    margin-bottom: 0 !important;
  }

  &__title {
    @apply text-3xl whitespace-pre-line;

    &:not(:last-child) {
      @apply mb-[18px];
    }

    &--small {
      @apply text-xl;

      @screen xxs {
        @apply text-2xl;
      }

      @screen sm {
        @apply text-3xl;

        &:not(:last-child) {
          @apply mb-[18px];
        }
      }
    }

    &--variant {
      @apply text-[39px];
    }
  }

  &__subtitle {
    @apply mx-auto;
  }

  &__info {
    @apply font-semibold;
  }
}

.header-container {
  @apply mx-auto flex flex-row border-1 p-5 items-center rounded-10 font-display;

  &__title {
    @apply font-bold text-[21px] leading-[26px];
  }

  img {
    @apply my-10 mx-20;
  }
}

strong {
  font-weight: 700;
}
</style>
